import(/* webpackMode: "eager" */ "/vercel/path0/src/app/musicraft/addons/page.tsx");
